/** ATO logbook page the spreadsheet comparison rests on; same page and date as /logbook-method. */
export const SPREADSHEET_SOURCE = {
  label: "ATO, logbook method",
  url: "https://www.ato.gov.au/businesses-and-organisations/income-deductions-and-concessions/income-and-deductions-for-business/deductions/deductions-for-motor-vehicle-expenses/logbook-method",
  checkedAt: "2026-10-27",
}
